<template>
    <div>
        
        <h1 class="display-3 ma-5 pa-5 indigo darken-1 white--text rounded-tl-xl" >Teste</h1>
        <v-divider></v-divider>



        

    </div>
</template>

<script>
//import firebase from 'firebase'
import {refAgenda, refBarbeiros} from '@/firebaseConfig'

    export default {
    
    data(){
        return {
        refAgenda: refAgenda,
        jsonAgenda: {},
        refBarbeiros: refBarbeiros,
        today: new Date().toISOString().substr(0, 10),
        barbeiroFiltrado: '',
        barbeiros: [],
        events: [],
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        focus: '',
        type: 'month',
        typeToLabel: {
            month: 'Month',
            week: 'Week',
            day: 'Day',
            '4day': '4 Days',
        },
         names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
         colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],

        }
    },
    
     mounted () {
      this.carregarAgenda();
  
    
    },
    methods:{
        mensagem(item){
          var hora = item.start.substring(item.start.length - 5);
          var dia = item.start.split("-")[2];
          dia = dia.substring(0,2)
          var telefone = item.cliente.telefone.replace("(","").replace(")","").replace("-","")
          var servico = item.servico.descricao
          // console.log(hora);
          // console.log(dia);
          let text = `https://api.whatsapp.com/send?phone=55${telefone}&text=Olá, gostaria de confirmar seu agendamento para às ${hora}, neste dia ${dia} na Barbearia Lisboa, para o serviço de ${servico}&app_absent=0`
          return text
        },
        buscarAgenda(){
           let dias = 15 * (((24 * 60) * 60) * 1000)
          let dataMinima = new Date().getTime()
          dataMinima = dataMinima - dias;
            this.events = []
             this.refAgenda.where("barbeiro.id", '==', this.barbeiroFiltrado).where("dataQuery", ">=", dataMinima).get().then((snap)=> {
                snap.forEach((doc)=>{                   
                      this.tratarAgendamento(doc);
                });
            });
            
        },
        carregarAgenda(){
          
          // let dataMinima = new Date().getTime()
          let dataMinima = 1635390000000
          let dataMaxima = 1635476400000
          
           this.events = []
            this.refAgenda.where("dataQuery", ">=", dataMinima).where("dataQuery","<=", dataMaxima).get()
            .then((snap)=> {
                snap.forEach((doc)=>{
                  
                  // this.tratarAgendamento(doc);
                  let agendamento = doc.data()

                  this.jsonAgenda.push({...agendamento})

                });
                // console.log(this.events);
            });
        },
        tratarAgendamento(doc){
            
            let agendamento = doc.data();
              if(doc.data().start.length != 16 || doc.data().end.length != 16){
                //console.log("remover", doc.data());
              }else{
                console.log(" ------ ");
                console.log("Nome",agendamento.name + " " + agendamento.id);
                console.log("Start",agendamento.start);
                console.log("End",agendamento.end);
                agendamento.start = this.corrigirData(doc.data().start)
                agendamento.end = this.corrigirData(doc.data().end)
                //console.log(doc.data());
                this.events.push({...agendamento})
                
              }
        },
        corrigirData(data){
          if(data.includes("T")){
            return data.replace("T"," ")
          }else{
            return data
          }
        },

        carregarBarbeiros(){
            this.refBarbeiros.get().then((snap)=> {
                snap.forEach((doc)=>{
                  // console.log(doc.data());
                    this.barbeiros.push({...doc.data()})
                });
            });
        },
        
        apagarAgendamento(){
            //this.selectedEvent.id
            if(confirm("Deseja cancelar este agendamento?")){
                this.refAgenda.doc(this.selectedEvent.id).delete().then(()=>{
    
                    // this.buscarAgenda();
                    this.atualizar();
                    this.selectedOpen = false;
                });
            }
        },

        atualizar(){
          console.log(this.barbeiroFiltrado);
          if(this.barbeiroFiltrado !== ''){
            this.buscarAgenda()
          }else{
            this.carregarAgenda()
          }

          try{
            this.selectedOpen = false
          }catch(err){
            console.log(err);
          }
        },
        viewDay ({ date }) {
            this.focus = date
            this.type = 'day'
        },
    
        
        setToday () {
            this.focus = ''
        },
        prev () {
            this.$refs.calendar.prev()
        },
        next () {
            this.$refs.calendar.next()
        },

        showEvent ({ nativeEvent, event }) {
            const open = () => {
            this.selectedEvent = event
            this.selectedElement = nativeEvent.target
            setTimeout(() => this.selectedOpen = true, 10)
            }

            if (this.selectedOpen) {
            this.selectedOpen = false
            setTimeout(open, 10)
            } else {
            open()
            }

            nativeEvent.stopPropagation()
        },

        updateRange ({ start, end }) {
            const events = []

            const min = new Date(`${start.date}T00:00:00`)
            const max = new Date(`${end.date}T23:59:59`)
            const days = (max.getTime() - min.getTime()) / 86400000
            const eventCount = this.rnd(days, days + 20)

            for (let i = 0; i < eventCount; i++) {
            const allDay = this.rnd(0, 3) === 0
            const firstTimestamp = this.rnd(min.getTime(), max.getTime())
            const first = new Date(firstTimestamp - (firstTimestamp % 900000))
            const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
            const second = new Date(first.getTime() + secondTimestamp)

            events.push({
                name: this.names[this.rnd(0, this.names.length - 1)],
                start: first,
                end: second,
                color: this.colors[this.rnd(0, this.colors.length - 1)],
                timed: !allDay,
            })
            }

            this.events = events
        },
        rnd (a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },
    },
    
    }
</script>

<style lang="scss" scoped>

</style>